import { render, staticRenderFns } from "./EditComments.vue?vue&type=template&id=e7b473b8&scoped=true"
import script from "./EditComments.vue?vue&type=script&lang=js"
export * from "./EditComments.vue?vue&type=script&lang=js"
import style0 from "./EditComments.vue?vue&type=style&index=0&id=e7b473b8&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e7b473b8",
  null
  
)

export default component.exports